import { Component, Injectable, EventEmitter, Output, Input, ɵɵdefineInjectable, ɵɵinject, ViewChild, NgModule } from '@angular/core';
import { HttpErrorResponse, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { catchError, first as first$1, map } from 'rxjs/operators';
import { of, BehaviorSubject } from 'rxjs';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { last, first, minBy, pickBy } from 'lodash';
import * as moment_ from 'moment';
import { BaseChartDirective, ChartsModule, ThemeService } from 'ng2-charts';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class SbxUiCoreComponent {
    constructor() { }
    /**
     * @return {?}
     */
    ngOnInit() {
    }
}
SbxUiCoreComponent.decorators = [
    { type: Component, args: [{
                selector: 'sbx-sbx-ui-core',
                template: `
    <p>
      sbx-ui-core works!
    </p>
  `
            }] }
];
/** @nocollapse */
SbxUiCoreComponent.ctorParameters = () => [];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AuthInterceptor {
    constructor() { }
    /**
     * @param {?} req
     * @param {?} next
     * @return {?}
     */
    intercept(req, next) {
        return next.handle(req).pipe(catchError((/**
         * @param {?} err
         * @return {?}
         */
        (err) => {
            if (err instanceof HttpErrorResponse) {
                if (err.status === 401) {
                    window.location.assign(this.getLoginUrl(window.location.href));
                }
                console.log('error');
                console.log(err);
                console.log(req);
            }
            return of(err);
        })));
    }
    /**
     * @param {?=} continueUrl
     * @return {?}
     */
    getLoginUrl(continueUrl) {
        return `http://account.sparkbox.co/login?continue=${continueUrl}`;
    }
}
AuthInterceptor.decorators = [
    { type: Injectable }
];
/** @nocollapse */
AuthInterceptor.ctorParameters = () => [];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class UserMenuComponent {
    constructor() {
        this.logoutClicked = new EventEmitter();
    }
    /**
     * @return {?}
     */
    ngOnInit() { }
    /**
     * @return {?}
     */
    onClick() {
        this.logoutClicked.next();
    }
}
UserMenuComponent.decorators = [
    { type: Component, args: [{
                selector: 'sbx-user-menu',
                template: "<ul class=\"user-menu\">\n  <li routerLink=\"/settings\" class=\"settings\">Settings</li>\n  <li (click)=\"onClick()\" class=\"signout\">Sign Out</li>\n</ul>",
                styles: [".user-menu{background:#fff;list-style:none;padding:0;z-index:100;margin:0;border-radius:5px;width:190px;box-shadow:rgba(0,0,0,.174) 0 2px 6px 0}.user-menu>li{text-align:left;padding:8px 0 8px 15px;cursor:pointer;font-size:14px;font-weight:400;font-family:\"Open Sans\";color:#000}.user-menu>li:hover{background:#ece9e9;border-radius:5px}"]
            }] }
];
/** @nocollapse */
UserMenuComponent.ctorParameters = () => [];
UserMenuComponent.propDecorators = {
    logoutClicked: [{ type: Output }]
};
if (false) {
    /** @type {?} */
    UserMenuComponent.prototype.logoutClicked;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class InsightHeaderComponent {
    constructor() {
        this.showUserMenu = false;
    }
    /**
     * @return {?}
     */
    ngOnInit() { }
    /**
     * @param {?} event
     * @return {?}
     */
    toggleUserMenu(event) { }
    /**
     * @return {?}
     */
    onLogoffClicked() { }
}
InsightHeaderComponent.decorators = [
    { type: Component, args: [{
                selector: 'sbx-insight-header',
                template: "<div class=\"navigation\">\n  <div class=\"brand\" [routerLink]=\"'/'\"></div>\n  <ul class=\"nav-buttons left\">\n    <ng-content select=\"[leftNavItems]\"></ng-content>\n  </ul>\n  <ul class=\"nav-buttons right\">\n    <ng-content select=\"[rightNavItems]\"></ng-content>\n    <li (click)=\"toggleUserMenu($event)\" class=\"user\" *ngIf=\"currentUserNickname\">\n      <span class=\"icon-user\"></span>\n      {{currentUserNickname}}\n      <sbx-user-menu *ngIf=\"showUserMenu\" class=\"sbx-user-menu\" (logoutClicked)=\"onLogoffClicked()\"></sbx-user-menu>\n    </li>\n  </ul>\n</div>",
                styles: [".navigation{height:70px}.navigation>*{display:inline-block}.brand{background-image:url(../../assets/wordmark.png);height:30px;background-repeat:no-repeat;background-position-x:9px;background-size:contain;width:220px;position:absolute;top:20px;left:20px;cursor:pointer}.nav-buttons{display:inline-block;margin:0;padding:0;position:absolute;top:18px;z-index:1111}.nav-buttons.left{left:305px}.nav-buttons.right{right:0;top:10px}.nav-buttons::ng-deep li{display:inline-block;font-size:18px;font-weight:400;margin:0 27px;cursor:pointer;position:relative;line-height:18px;padding:6px 12px}.nav-buttons::ng-deep li.highlight{background:#fae8e5}.nav-buttons .user .icon-user{opacity:.7;font-size:15px;font-weight:700;padding-right:4px}.sbx-user-menu{position:absolute;top:42px;right:0;line-height:normal}"]
            }] }
];
/** @nocollapse */
InsightHeaderComponent.ctorParameters = () => [];
InsightHeaderComponent.propDecorators = {
    currentUserNickname: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    InsightHeaderComponent.prototype.currentUserNickname;
    /** @type {?} */
    InsightHeaderComponent.prototype.showUserMenu;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const moment = moment_;
/** @type {?} */
const recommendationDetails = {
    sku_desc: 'Knitted Round Neck Jumper',
    sku_id: '103289700',
    h2_desc: 'Knitwear',
    h3_desc: 'Jumper',
    season: '2020 / AW',
    age: '10 weeks',
    current_price: '€30',
    cost_price: '€10',
    current_margin: '70%',
    image_url: '../../assets/demo-image.png',
};
/** @type {?} */
const base = 350;
/** @type {?} */
const pe = -2.2;
/** @type {?} */
const startInventory = 9000;
/** @type {?} */
const regularPrice = 29.99;
/** @type {?} */
const costPrice = 12;
/** @type {?} */
const disposalCost = 4;
/**
 * @return {?}
 */
function getMockRecommendations() {
    /** @type {?} */
    const recForecast = [{ cal_date: '2020-11-26T00:00:00.000Z', price: 29.99, seasonality: 1.30 },
        { cal_date: '2020-12-03T00:00:00.000Z', price: 29.99, seasonality: 1.25 },
        { cal_date: '2020-12-10T00:00:00.000Z', price: 29.99, seasonality: 1.15 },
        { cal_date: '2020-12-17T00:00:00.000Z', price: 29.99, seasonality: 1.10 },
        { cal_date: '2020-12-24T00:00:00.000Z', price: 25, seasonality: 1.30 },
        { cal_date: '2020-12-31T00:00:00.000Z', price: 25, seasonality: 1.20 },
        { cal_date: '2021-01-07T00:00:00.000Z', price: 25, seasonality: 1.10 },
        { cal_date: '2021-01-14T00:00:00.000Z', price: 25, seasonality: 1.00 },
        { cal_date: '2021-01-21T00:00:00.000Z', price: 25, seasonality: 0.90 },
        { cal_date: '2021-01-28T00:00:00.000Z', price: 25, seasonality: 0.80 },
        { cal_date: '2021-02-04T00:00:00.000Z', price: 25, seasonality: 0.70 },
        { cal_date: '2021-02-11T00:00:00.000Z', price: 25, seasonality: 0.40 },
        { cal_date: '2021-02-18T00:00:00.000Z', price: 25, seasonality: 0.20 }];
    /** @type {?} */
    const baseLineRecs = [{ cal_date: '2020-10-29T00:00:00.000Z', price: 29.99, net_sales_u: 280,
            start_inventory: 9000, seasonality: 0.80, endingInventory: 8720, type: 'baseLine' },
        { cal_date: '2020-11-05T00:00:00.000Z', price: 29.99, seasonality: 0.90 },
        { cal_date: '2020-11-12T00:00:00.000Z', price: 29.99, seasonality: 0.95 },
        { cal_date: '2020-11-19T00:00:00.000Z', price: 29.99, seasonality: 0.90 },
        { cal_date: '2020-11-26T00:00:00.000Z', price: 29.99, seasonality: 1.30 },
        { cal_date: '2020-12-03T00:00:00.000Z', price: 29.99, seasonality: 1.25 },
        { cal_date: '2020-12-10T00:00:00.000Z', price: 29.99, seasonality: 1.15 },
        { cal_date: '2020-12-17T00:00:00.000Z', price: 29.99, seasonality: 1.10 },
        { cal_date: '2020-12-24T00:00:00.000Z', price: 29.99, seasonality: 1.30 },
        { cal_date: '2020-12-31T00:00:00.000Z', price: 29.99, seasonality: 1.20 },
        { cal_date: '2021-01-07T00:00:00.000Z', price: 29.99, seasonality: 1.10 },
        { cal_date: '2021-01-14T00:00:00.000Z', price: 29.99, seasonality: 1.00 },
        { cal_date: '2021-01-21T00:00:00.000Z', price: 29.99, seasonality: 0.90 },
        { cal_date: '2021-01-28T00:00:00.000Z', price: 29.99, seasonality: 0.80 },
        { cal_date: '2021-02-04T00:00:00.000Z', price: 29.99, seasonality: 0.70 },
        { cal_date: '2021-02-11T00:00:00.000Z', price: 29.99, seasonality: 0.40 },
        { cal_date: '2021-02-18T00:00:00.000Z', price: 29.99, seasonality: 0.20 }];
    /** @type {?} */
    const mockRecommendations = [];
    /** @type {?} */
    let netSalesSum = 0;
    /** @type {?} */
    let netSalesSumProduct = 0;
    /** @type {?} */
    let forecastSalesSum = 0;
    /** @type {?} */
    let sumProductSales = 0;
    baseLineRecs.forEach((/**
     * @param {?} p
     * @param {?} i
     * @return {?}
     */
    (p, i) => {
        /** @type {?} */
        const prevData = mockRecommendations.filter((/**
         * @param {?} __0
         * @return {?}
         */
        ({ cal_date, type }) => moment(p.cal_date).diff(moment(cal_date), 'days') === 7
            && (type === 'baseLine' || type === 'productHistory')));
        /** @type {?} */
        const netSalesUnits = p.net_sales_u ? p.net_sales_u : base * p.seasonality;
        /** @type {?} */
        const startInventory = i > 0 ? +(prevData[0].endingInventory).toFixed(1) : 9000;
        netSalesSum = netSalesSum + netSalesUnits;
        netSalesSumProduct = netSalesSumProduct + (netSalesUnits * p.price);
        /** @type {?} */
        const cummulativeMargin = i > 0 ? ((netSalesSumProduct - costPrice * netSalesSum)) - ((startInventory - netSalesUnits) * disposalCost) :
            ((p.price * p.net_sales_u - costPrice * p.net_sales_u)) - ((p.start_inventory - netSalesUnits) * disposalCost);
        mockRecommendations.push(Object.assign({}, p, { net_sales_u: netSalesUnits, endingInventory: i === 0 ? p.endingInventory : (startInventory - netSalesUnits), type: i > 3 ? 'baseLine' : 'productHistory', fcst_end_stock_u: startInventory - netSalesUnits, startInventory, fcst_cum_margin: cummulativeMargin, netSalesSum,
            netSalesSumProduct }));
    }));
    recForecast.forEach((/**
     * @param {?} rec
     * @param {?} index
     * @return {?}
     */
    (rec, index) => {
        /** @type {?} */
        const lastActualValues = last(mockRecommendations.filter((/**
         * @param {?} __0
         * @return {?}
         */
        ({ type }) => type === 'productHistory')));
        /** @type {?} */
        const firstBaseLineData = first(mockRecommendations.filter((/**
         * @param {?} __0
         * @return {?}
         */
        ({ type }) => type === 'baseLine')));
        /** @type {?} */
        const prevRec = index > 0 ? mockRecommendations.filter((/**
         * @param {?} __0
         * @return {?}
         */
        ({ cal_date, type }) => moment(rec.cal_date).diff(moment(cal_date), 'days') === 7 && type === 'recForecast')) : lastActualValues;
        /** @type {?} */
        const discount = ((regularPrice - rec.price) / regularPrice) * -1;
        /** @type {?} */
        const startingInventory = index > 0 ? prevRec[0].fcst_end_stock_u : lastActualValues.endingInventory;
        /** @type {?} */
        const fcstNetSalesUnits = index > 0 ? Math.min((base + (base * pe * discount)) * rec.seasonality, prevRec[0].fcst_end_stock_u) : base * rec.seasonality;
        forecastSalesSum = index > 0 ? forecastSalesSum + fcstNetSalesUnits : lastActualValues.netSalesSum + fcstNetSalesUnits;
        sumProductSales = index > 0 ? (sumProductSales + (fcstNetSalesUnits * rec.price)) : (lastActualValues.netSalesSum + fcstNetSalesUnits) * lastActualValues.price;
        /** @type {?} */
        const cummulativeMargin = index > 0 ? ((sumProductSales - costPrice * forecastSalesSum)) - ((startingInventory - fcstNetSalesUnits) * disposalCost) :
            ((rec.price * firstBaseLineData.netSalesSum - costPrice * firstBaseLineData.netSalesSum)) - ((firstBaseLineData.startInventory - fcstNetSalesUnits) * disposalCost);
        mockRecommendations.push(Object.assign({}, rec, { fcst_net_sales_u: fcstNetSalesUnits.toFixed(1), endingInventory: index === 0 ? lastActualValues.endingInventory : (startInventory - fcstNetSalesUnits), startingInventory, fcst_end_stock_u: startingInventory - fcstNetSalesUnits, type: 'recForecast', fcst_cum_margin: cummulativeMargin, sumProductSales,
            forecastSalesSum }));
    }));
    return mockRecommendations;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class PlugAndPlayService {
    /**
     * @param {?} http
     */
    constructor(http) {
        this.http = http;
    }
    /**
     * @param {?} price
     * @return {?}
     */
    savePriceChange(price) {
        this.http.post('/api/market/forecast-assistant/save-price-change', price).pipe(first$1()).subscribe();
    }
}
PlugAndPlayService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
PlugAndPlayService.ctorParameters = () => [
    { type: HttpClient }
];
/** @nocollapse */ PlugAndPlayService.ngInjectableDef = ɵɵdefineInjectable({ factory: function PlugAndPlayService_Factory() { return new PlugAndPlayService(ɵɵinject(HttpClient)); }, token: PlugAndPlayService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    PlugAndPlayService.prototype.http;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const moment$1 = moment_;
class PlugAndPlayComponent {
    /**
     * @param {?} plugAndPlayService
     */
    constructor(plugAndPlayService) {
        this.plugAndPlayService = plugAndPlayService;
        this.recommendationSummary = recommendationDetails;
        this.updatedNetSalesUnits = [];
        this.updatedInventory = [];
        this.updatedCummulativeMargin = [];
        this.lineChartColors = [
            {
                borderColor: '#6f6f6f',
                pointBorderColor: 'transparent',
                pointHoverBackgroundColor: '#6f6f6f',
                pointHoverBorderColor: '#6f6f6f'
            },
            {
                borderColor: '#bdb7b7',
                pointBorderColor: '#fff',
                pointHoverBackgroundColor: '#fff',
                pointHoverBorderColor: '#bdb7b7'
            },
            {
                borderColor: '#ffa3c7',
                pointBorderColor: '#fff',
                pointHoverBackgroundColor: '#fff',
                pointHoverBorderColor: 'rgba(148,159,177,0.8)'
            },
        ];
        this.cummulativeChartColors = [{
                borderColor: '#bdb7b7',
                pointBorderColor: '#fff',
                pointHoverBackgroundColor: '#fff',
                pointHoverBorderColor: '#bdb7b7'
            },
            {
                borderColor: '#ffa3c7',
                pointBorderColor: '#fff',
                pointHoverBackgroundColor: '#fff',
                pointHoverBorderColor: 'rgba(148,159,177,0.8)'
            },
        ];
        this.lineChartWidth = 412;
        this.lineChartHeight = 300;
        this.showDemoModal = false;
        this.startingInventory = startInventory;
        this.recommendationOptions = getMockRecommendations();
        this.rowData = this.recommendationOptions.filter((/**
         * @param {?} __0
         * @return {?}
         */
        ({ type }) => type === 'recForecast'));
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        /** @type {?} */
        let forecastNetSalesUnits = this.rowData.map((/**
         * @param {?} __0
         * @return {?}
         */
        ({ fcst_net_sales_u, cal_date }) => {
            return {
                x: moment$1(cal_date).format('MM/DD/YY'),
                y: fcst_net_sales_u
            };
        }));
        /** @type {?} */
        const actualNetSales = this.recommendationOptions.filter((/**
         * @param {?} __0
         * @return {?}
         */
        ({ type }) => type === 'productHistory')).map((/**
         * @param {?} __0
         * @return {?}
         */
        ({ net_sales_u, cal_date }) => {
            return {
                x: moment$1(cal_date).format('MM/DD/YY'),
                y: net_sales_u
            };
        }));
        /** @type {?} */
        const actualInventory = this.recommendationOptions.filter((/**
         * @param {?} __0
         * @return {?}
         */
        ({ type }) => type === 'productHistory')).map((/**
         * @param {?} __0
         * @return {?}
         */
        ({ fcst_end_stock_u, cal_date }) => {
            return {
                x: moment$1(cal_date).format('MM/DD/YY'),
                y: fcst_end_stock_u
            };
        }));
        this.noActionData = this.recommendationOptions.filter((/**
         * @param {?} __0
         * @return {?}
         */
        ({ type }) => type === 'baseLine'));
        /** @type {?} */
        let noActionNetSalesUnits = this.noActionData.map((/**
         * @param {?} data
         * @return {?}
         */
        (data) => {
            return {
                x: moment$1(data.cal_date).format('MM/DD/YY'),
                y: data.net_sales_u
            };
        }));
        /** @type {?} */
        let noActionInventory = this.noActionData.map((/**
         * @param {?} data
         * @return {?}
         */
        (data) => {
            return {
                x: moment$1(data.cal_date).format('MM/DD/YY'),
                y: data.fcst_end_stock_u
            };
        }));
        /** @type {?} */
        let forecastInventory = this.rowData.map((/**
         * @param {?} __0
         * @return {?}
         */
        ({ fcst_end_stock_u, cal_date }) => {
            return {
                x: moment$1(cal_date).format('MM/DD/YY'),
                y: fcst_end_stock_u.toFixed(1)
            };
        }));
        forecastInventory = [last(actualInventory), ...forecastInventory];
        noActionInventory = [last(actualInventory), ...noActionInventory];
        forecastNetSalesUnits = [last(actualNetSales), ...forecastNetSalesUnits];
        noActionNetSalesUnits = [last(actualNetSales), ...noActionNetSalesUnits];
        /** @type {?} */
        const forecastCummulativeMargin = this.rowData.map((/**
         * @param {?} __0
         * @return {?}
         */
        ({ fcst_cum_margin, cal_date }) => {
            return {
                x: moment$1(cal_date).format('MM/DD/YY'),
                y: fcst_cum_margin
            };
        }));
        /** @type {?} */
        const noActionCummulativeMargin = this.noActionData.map((/**
         * @param {?} data
         * @return {?}
         */
        (data) => {
            return {
                x: moment$1(data.cal_date).format('MM/DD/YY'),
                y: data.fcst_cum_margin
            };
        }));
        this.netSalesUnitsChartData = {
            title: 'Net Sales Units',
            lineChartData: [
                { data: actualNetSales, label: 'Actual', fill: false },
                { data: noActionNetSalesUnits, label: 'No Action', fill: false, borderDash: [2, 2] },
                { data: (this.recLabel !== 'No action') ? forecastNetSalesUnits : '', label: this.recLabel,
                    borderDash: [2, 2], fill: false }
            ],
            legend: false,
        };
        this.inventoryChartData = {
            title: 'Inventory',
            lineChartData: [
                { data: actualInventory, label: 'Actual', fill: false },
                { data: noActionInventory, label: 'No Action', fill: false, borderDash: [2, 2] },
                { data: (this.recLabel !== 'No action') ? forecastInventory : '', label: this.recLabel,
                    borderDash: [2, 2], fill: false }
            ],
            legend: false,
        };
        this.cumulativeChartData = {
            title: 'Cummulative Margin',
            lineChartData: [
                { data: noActionCummulativeMargin, label: 'No Action', fill: false, borderDash: [2, 2] },
                { data: (this.recLabel !== 'No action') ? forecastCummulativeMargin : '', label: this.recLabel,
                    borderDash: [2, 2], fill: false }
            ],
            legend: false,
        };
    }
    /**
     * @param {?} event
     * @return {?}
     */
    omitAlphabets(event) {
        /** @type {?} */
        const key = event.keyCode;
        return ((key > 47 && key < 58) || key == 45 || key == 46);
    }
    /**
     * @param {?} date
     * @param {?} newPrice
     * @return {?}
     */
    onValueChange(date, newPrice) {
        if (!isNaN(newPrice)) {
            this.plugAndPlayService.savePriceChange(this.rowData.map((/**
             * @param {?} __0
             * @return {?}
             */
            ({ price }) => +price)));
            /** @type {?} */
            const lastActualData = last(this.recommendationOptions.filter((/**
             * @param {?} __0
             * @return {?}
             */
            ({ type }) => type === 'productHistory')));
            /** @type {?} */
            const existingForecast = this.recommendationOptions.filter((/**
             * @param {?} __0
             * @return {?}
             */
            ({ type }) => type === 'recForecast'));
            /** @type {?} */
            const minCalDate = minBy(existingForecast.map((/**
             * @param {?} __0
             * @return {?}
             */
            ({ cal_date }) => cal_date)));
            /** @type {?} */
            let updatedForecast = this.rowData.map((/**
             * @param {?} forecast
             * @return {?}
             */
            (forecast) => {
                /** @type {?} */
                const LWEndInventory = existingForecast.filter((/**
                 * @param {?} forecast
                 * @return {?}
                 */
                (forecast) => moment$1(date).diff(moment$1(forecast.cal_date), 'days') === 7))
                    .map((/**
                 * @param {?} __0
                 * @return {?}
                 */
                ({ fcst_end_stock_u }) => fcst_end_stock_u));
                /** @type {?} */
                const prevSumProductSales = date > minCalDate ? existingForecast.filter((/**
                 * @param {?} forecast
                 * @return {?}
                 */
                (forecast) => moment$1(date).diff(moment$1(forecast.cal_date), 'days') === 7))
                    .map((/**
                 * @param {?} __0
                 * @return {?}
                 */
                ({ sumProductSales }) => sumProductSales)) : lastActualData.netSalesSum * regularPrice;
                /** @type {?} */
                const prevForecastSales = date > minCalDate ? existingForecast.filter((/**
                 * @param {?} forecast
                 * @return {?}
                 */
                (forecast) => moment$1(date).diff(moment$1(forecast.cal_date), 'days') === 7))
                    .map((/**
                 * @param {?} __0
                 * @return {?}
                 */
                ({ forecastSalesSum }) => forecastSalesSum)) : lastActualData.netSalesSum;
                if (forecast.cal_date === date) {
                    /** @type {?} */
                    const discount = ((regularPrice - newPrice) / regularPrice) * -1;
                    this.startingInventory = date > minCalDate ? +(LWEndInventory[0]).toFixed(1) : lastActualData.fcst_end_stock_u;
                    /** @type {?} */
                    const fcstNetSalesUnits = Math.min((base + (base * pe * discount)) * forecast.seasonality, this.startingInventory);
                    /** @type {?} */
                    const cummulativeMargin = date > minCalDate ? ((prevSumProductSales[0] + newPrice * fcstNetSalesUnits) - ((prevForecastSales[0] + fcstNetSalesUnits) * costPrice)) -
                        ((this.startingInventory - fcstNetSalesUnits) * disposalCost) : (((lastActualData.price * lastActualData.netSalesSum + fcstNetSalesUnits * newPrice) - costPrice * (lastActualData.netSalesSum + fcstNetSalesUnits))) -
                        ((lastActualData.fcst_end_stock_u - fcstNetSalesUnits) * disposalCost);
                    return Object.assign({}, forecast, { price: newPrice, fcst_net_sales_u: fcstNetSalesUnits, fcst_end_stock_u: (this.startingInventory - fcstNetSalesUnits).toFixed(1), fcst_cum_margin: cummulativeMargin.toFixed(1) });
                }
                return forecast;
            }));
            this.rowData = updatedForecast;
            this.updatedNetSalesUnits = this.rowData.map((/**
             * @param {?} __0
             * @return {?}
             */
            ({ fcst_net_sales_u, cal_date }) => {
                return {
                    x: moment$1(cal_date).format('MM/DD/YY'),
                    y: fcst_net_sales_u
                };
            }));
            this.updatedNetSalesUnits = [{ x: moment$1(lastActualData.cal_date).format('MM/DD/YY'), y: lastActualData.net_sales_u }, ...this.updatedNetSalesUnits];
            this.updatedInventory = this.rowData.map((/**
             * @param {?} __0
             * @return {?}
             */
            ({ fcst_end_stock_u, cal_date }) => {
                return {
                    x: moment$1(cal_date).format('MM/DD/YY'),
                    y: fcst_end_stock_u
                };
            }));
            this.updatedInventory = [{ x: moment$1(lastActualData.cal_date).format('MM/DD/YY'), y: lastActualData.fcst_end_stock_u }, ...this.updatedInventory];
            this.updatedCummulativeMargin = this.rowData.map((/**
             * @param {?} __0
             * @return {?}
             */
            ({ fcst_cum_margin, cal_date }) => {
                return {
                    x: moment$1(cal_date).format('MM/DD/YY'),
                    y: +fcst_cum_margin
                };
            }));
        }
    }
    /**
     * @return {?}
     */
    toggleDemoModal() {
        this.showDemoModal = !this.showDemoModal;
    }
    /**
     * @return {?}
     */
    onCloseClicked() {
        this.showDemoModal = false;
    }
}
PlugAndPlayComponent.decorators = [
    { type: Component, args: [{
                selector: 'sbx-plug-and-play',
                template: "<div class=\"top-bar\">\n<span class=\"brand\" [style.backgroundImage]=\"'url(../../assets/wordmark.png)'\"></span>\n<span class=\"right-align\"><button (click)=\"toggleDemoModal()\">get in touch</button></span>\n</div>\n<div class=\"content-wrapper\">\n    <span class=\"search\">\n      <input value=\"103289700\">\n      <i class=\"fas fa-search search-icon\"></i>\n    </span>\n    <div class=\"prev\">\n      <div>\n        <span class=\"icon-arrow-left\"></span>\n      </div>\n    </div>\n      <div class=\"recommendation-detail-container\">\n        <div class=\"recommendation\">\n          <div class=\"recommendation__image\" [style.backgroundImage]=\"'url('+recommendationSummary.image_url+')'\">\n            <img [src]=\"recommendationSummary.image_url\" onerror=\"this.style.display='none'\" />\n          </div>\n          <div class=\"recommendation__summary\">\n            <h3 class=\"title sku-desc\">{{recommendationSummary.sku_desc}} </h3>\n            <h4 class=\"ref\">{{recommendationSummary.sku_id}}</h4>\n            <h4 class=\"department-category\">{{recommendationSummary.h2_desc}}/ {{recommendationSummary.h3_desc}}</h4>\n            <h4 class=\"season-collection\">{{recommendationSummary.season}}</h4>\n            <h4 class=\"age\"><span>age</span><span>{{recommendationSummary.age}}</span></h4>\n            <h4 class=\"cur-price\"><span>current price</span><span>{{recommendationSummary.current_price}}</span>\n            </h4>\n            <h4 class=\"cur-price\"><span>cost price</span><span>{{recommendationSummary.cost_price}}</span>\n            </h4>\n            <h4 class=\"current-margin\"><span>current margin</span>\n              <span>{{recommendationSummary.current_margin}}</span>\n            </h4> \n          </div>\n        </div>\n        <div class=\"detail\">\n          <sbx-line-chart class=\"chart\" [chartData]=\"netSalesUnitsChartData\" [lineChartColors]=\"lineChartColors\" [updatedForecast] =\"updatedNetSalesUnits\" [lineChartWidth]=\"lineChartWidth\" [lineChartHeight]=\"lineChartHeight\"></sbx-line-chart>\n            <sbx-line-chart class=\"chart\" [chartData]=\"inventoryChartData\" [lineChartColors]=\"lineChartColors\" [updatedForecast] =\"updatedInventory\" [lineChartWidth]=\"lineChartWidth\" [lineChartHeight]=\"lineChartHeight\"></sbx-line-chart>\n            <sbx-line-chart class=\"chart\" [chartData]=\"cumulativeChartData\" [lineChartColors]=\"cummulativeChartColors\" [updatedForecast] =\"updatedCummulativeMargin\" [lineChartWidth]=\"lineChartWidth\" [lineChartHeight]=\"lineChartHeight\"></sbx-line-chart>\n            <div class=\"legend\">\n                <hr class=\"actual\"/>\n                <span>actual</span>\n                <hr class=\"dotted no-action\"/>\n                <span>no action</span>\n                <hr class=\"dotted type\"/>\n                <span>forecast</span>\n            </div>\n          <div class=\"edit-price\">\n            <h3 class=\"edit-title\">Edit Price</h3>\n            <div class= \"row\">\n              <div class=\"forecast-data\">\n                <span class=\"column\">Price</span>\n              </div>\n              <div *ngFor=\"let forecast of rowData\" class=\"forecast-data\" >\n                  <div>{{forecast.cal_date | date:'dd/MM/yy'}}</div>\n                  <input type=\"text\" pattern=\"/^[0-9]*$/\" [(ngModel)]=\"forecast.price\" (keypress)=\"omitAlphabets($event)\" (change)=\"onValueChange(forecast.cal_date, +$event.target.value)\">\n              </div>\n              </div>\n              <div>\n                <div class= \"row\">\n                <div class=\"no-action-title\">No Action</div>\n                <div *ngFor=\"let forecast of noActionData\" class=\"noaction-data\" >\n                  <span>{{forecast.price}}</span>\n                </div>\n              </div>\n              </div>\n            </div> \n        </div>\n      </div>\n      <div class=\"next\">\n        <div>\n          <span class=\"icon-arrow-right\"></span>\n          <span class=\"more\">next</span>\n        </div>\n      </div>\n  </div>\n  <div class=\"disclaimer\">*this data is for demonstration purpose only</div>\n  <sbx-demo-form *ngIf=\"showDemoModal\" (closeClicked)=\"onCloseClicked()\"></sbx-demo-form>\n",
                styles: [".content-wrapper{display:-webkit-box;display:flex;padding:5em 0;box-sizing:border-box;font-family:Lato,sans-serif}.content-wrapper .recommendation-detail-container{height:100%;background:#fff;-webkit-box-flex:1;flex-grow:1;border-radius:15px;padding:40px;display:-webkit-box;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;flex-direction:row;box-sizing:border-box;position:relative;box-shadow:rgba(255,163,199,.6) 0 0 5px 2px;margin-top:80px}.content-wrapper .recommendation-detail-container .recommendation{width:286px;height:100%;margin-right:60px;margin-top:5px;position:relative}.content-wrapper .recommendation-detail-container .recommendation .recommendation__image{height:280px;width:97%;position:relative;background:0 0/cover;overflow:hidden;margin-bottom:1.6em}.content-wrapper .recommendation-detail-container .recommendation .recommendation__summary{margin-top:50px}.content-wrapper .recommendation-detail-container .recommendation .recommendation__summary h3.sku-desc{margin-bottom:0;text-transform:uppercase}.content-wrapper .recommendation-detail-container .recommendation .recommendation__summary .age,.content-wrapper .recommendation-detail-container .recommendation .recommendation__summary .cur-price,.content-wrapper .recommendation-detail-container .recommendation .recommendation__summary .current-margin,.content-wrapper .recommendation-detail-container .recommendation .recommendation__summary .department-category,.content-wrapper .recommendation-detail-container .recommendation .recommendation__summary .full-price,.content-wrapper .recommendation-detail-container .recommendation .recommendation__summary .ref,.content-wrapper .recommendation-detail-container .recommendation .recommendation__summary .season-collection{margin-top:0;font-family:Lato,sans-serif;font-size:15px;line-height:1.5;font-weight:400}.content-wrapper .recommendation-detail-container .recommendation .recommendation__summary .age>span:first-of-type,.content-wrapper .recommendation-detail-container .recommendation .recommendation__summary .cur-price>span:first-of-type,.content-wrapper .recommendation-detail-container .recommendation .recommendation__summary .current-margin>span:first-of-type,.content-wrapper .recommendation-detail-container .recommendation .recommendation__summary .full-price>span:first-of-type{width:190px;display:inline-block}.content-wrapper .recommendation-detail-container .recommendation .recommendation__summary .cur-price,.content-wrapper .recommendation-detail-container .recommendation .recommendation__summary .department-category,.content-wrapper .recommendation-detail-container .recommendation .recommendation__summary .season-collection{margin-bottom:0}.content-wrapper .recommendation-detail-container .detail{-webkit-box-flex:1;flex-grow:1;overflow:hidden;height:100%;font-family:Lato,sans-serif;font-size:15px;line-height:1.5}.content-wrapper .recommendation-detail-container .detail .projections>span{font-weight:600}.next,.prev{visibility:hidden;width:7em;position:relative}.search{position:fixed;top:80px;left:115px}.search input{border-radius:3px;height:30px;padding-left:10px;border:2px solid #6f6f6f;font-family:lato;width:200px}.search .search-icon{position:absolute;top:10px;right:10px;font-size:14px;color:#6f6f6f}.right-align{position:absolute;top:20px;right:20px}.right-align button{font-size:18px;font-family:Rubik,sans-serif;font-weight:500;color:#fff;padding:7px 17px 6px;background:#33235c;border-radius:10px;text-transform:lowercase;border:none;cursor:pointer}.edit-price{margin:25px 0}.edit-price .column{margin-right:45px}.edit-price .edit-title{border-bottom:2px solid #dedede;padding-bottom:10px}.edit-price .row{display:-webkit-box;display:flex;-webkit-box-pack:justify;justify-content:space-between}.edit-price .row:first-of-type{-webkit-box-align:end;align-items:flex-end}.edit-price .row div{margin-top:10px;display:inline-block}.edit-price .forecast-data div{display:block;font-weight:600}.edit-price .forecast-data input{width:60px;padding-left:5px;border-radius:3px;margin-top:10px;border:1px solid #dedede;height:25px;font-family:lato}.edit-price .no-action-title{display:inline-block;margin-right:15px}.edit-price .noaction-data{width:69px;font-size:14px}.edit-price .noaction-data span{padding-left:5px}.disclaimer{position:fixed;bottom:75px;right:110px}.legend{display:block;margin-top:30px;margin-right:52px}.legend hr{display:inline-block;width:30px;margin:10px;vertical-align:middle}.legend hr.actual{border:1px solid #6f6f6f}.legend hr.dotted{color:#fff;background-color:#fff}.legend hr.dotted.no-action{border:2px dotted #bdb7b7}.legend hr.dotted.type{border:2px dotted #ffa3c7}.brand{height:30px;background-repeat:no-repeat;background-position-x:9px;background-size:contain;width:220px;position:absolute;top:20px;left:20px}"]
            }] }
];
/** @nocollapse */
PlugAndPlayComponent.ctorParameters = () => [
    { type: PlugAndPlayService }
];
if (false) {
    /** @type {?} */
    PlugAndPlayComponent.prototype.recommendationSummary;
    /** @type {?} */
    PlugAndPlayComponent.prototype.recommendationOptions;
    /** @type {?} */
    PlugAndPlayComponent.prototype.rowData;
    /** @type {?} */
    PlugAndPlayComponent.prototype.netSalesUnitsChartData;
    /** @type {?} */
    PlugAndPlayComponent.prototype.inventoryChartData;
    /** @type {?} */
    PlugAndPlayComponent.prototype.cumulativeChartData;
    /** @type {?} */
    PlugAndPlayComponent.prototype.updatedNetSalesUnits;
    /** @type {?} */
    PlugAndPlayComponent.prototype.updatedInventory;
    /** @type {?} */
    PlugAndPlayComponent.prototype.updatedCummulativeMargin;
    /** @type {?} */
    PlugAndPlayComponent.prototype.noActionData;
    /** @type {?} */
    PlugAndPlayComponent.prototype.lineChartColors;
    /** @type {?} */
    PlugAndPlayComponent.prototype.cummulativeChartColors;
    /** @type {?} */
    PlugAndPlayComponent.prototype.recLabel;
    /** @type {?} */
    PlugAndPlayComponent.prototype.lineChartWidth;
    /** @type {?} */
    PlugAndPlayComponent.prototype.lineChartHeight;
    /** @type {?} */
    PlugAndPlayComponent.prototype.showDemoModal;
    /** @type {?} */
    PlugAndPlayComponent.prototype.startingInventory;
    /**
     * @type {?}
     * @private
     */
    PlugAndPlayComponent.prototype.plugAndPlayService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class LineChartComponent {
    constructor() {
        this.lineChartLegend = true;
        this.lineChartType = 'line';
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        if (changes.updatedForecast && changes.updatedForecast.currentValue.length > 0) {
            if (this.chartData.lineChartData[2]) {
                this.chartData.lineChartData[2].data = changes.updatedForecast.currentValue;
            }
            else {
                this.chartData.lineChartData[1].data = changes.updatedForecast.currentValue;
            }
            this.chart.update();
        }
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.lineChartData = this.chartData.lineChartData;
        this.lineChartLegend = this.chartData.legend;
        this.lineChartOptions = {
            responsive: true,
            maintainAspectRatio: false,
            title: {
                text: this.chartData.title,
                display: true
            },
            scales: {
                xAxes: [{
                        type: 'time',
                        time: {
                            unit: 'week',
                            displayFormats: {
                                week: 'DD/MM/YY'
                            },
                        },
                        ticks: {
                            autoSkip: true,
                            maxTicksLimit: 5,
                            maxRotation: 0,
                            minRotation: 0
                        }
                    }],
                yAxes: [
                    {
                        id: 'y-axis-0',
                        position: 'left',
                    }
                ]
            }
        };
    }
}
LineChartComponent.decorators = [
    { type: Component, args: [{
                selector: 'sbx-line-chart',
                template: "<div class=\"line-chart\">\n    <canvas baseChart [width]=\"lineChartWidth\" [height]=\"lineChartHeight\" [datasets]=\"lineChartData\" [options]=\"lineChartOptions\" [colors]=\"lineChartColors\"\n    [legend]=\"lineChartLegend\" [chartType]=\"lineChartType\">\n    </canvas>\n</div>\n",
                styles: [".line-chart{display:inline-block}"]
            }] }
];
/** @nocollapse */
LineChartComponent.ctorParameters = () => [];
LineChartComponent.propDecorators = {
    chartData: [{ type: Input }],
    lineChartColors: [{ type: Input }],
    updatedForecast: [{ type: Input }],
    lineChartWidth: [{ type: Input }],
    lineChartHeight: [{ type: Input }],
    chart: [{ type: ViewChild, args: [BaseChartDirective, { static: true },] }]
};
if (false) {
    /** @type {?} */
    LineChartComponent.prototype.chartData;
    /** @type {?} */
    LineChartComponent.prototype.lineChartColors;
    /** @type {?} */
    LineChartComponent.prototype.updatedForecast;
    /** @type {?} */
    LineChartComponent.prototype.lineChartWidth;
    /** @type {?} */
    LineChartComponent.prototype.lineChartHeight;
    /** @type {?} */
    LineChartComponent.prototype.lineChartData;
    /** @type {?} */
    LineChartComponent.prototype.lineChartOptions;
    /** @type {?} */
    LineChartComponent.prototype.lineChartLegend;
    /** @type {?} */
    LineChartComponent.prototype.lineChartType;
    /** @type {?} */
    LineChartComponent.prototype.chart;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class DemoFormService {
    /**
     * @param {?} http
     */
    constructor(http) {
        this.http = http;
    }
    /**
     * @param {?} __0
     * @return {?}
     */
    submitDemoRequest({ message, email: userEmail, name }) {
        /** @type {?} */
        const action = `[MARKET DEMO REQUEST] Name: ${name} | Message: ${message}`;
        return this.http.post('/api/market/users/request-demo', { userEmail, action });
    }
}
DemoFormService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root',
            },] }
];
/** @nocollapse */
DemoFormService.ctorParameters = () => [
    { type: HttpClient }
];
/** @nocollapse */ DemoFormService.ngInjectableDef = ɵɵdefineInjectable({ factory: function DemoFormService_Factory() { return new DemoFormService(ɵɵinject(HttpClient)); }, token: DemoFormService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    DemoFormService.prototype.http;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class DemoFormComponent {
    /**
     * @param {?} demoFormService
     */
    constructor(demoFormService) {
        this.demoFormService = demoFormService;
        this.closeClicked = new EventEmitter();
    }
    /**
     * @return {?}
     */
    ngOnInit() { }
    /**
     * @return {?}
     */
    submit() {
        this.demoFormService.submitDemoRequest({ email: this.email, message: this.message, name: this.name }).subscribe((/**
         * @return {?}
         */
        () => {
            this.close();
        }));
    }
    /**
     * @return {?}
     */
    close() {
        this.closeClicked.emit();
    }
}
DemoFormComponent.decorators = [
    { type: Component, args: [{
                selector: 'sbx-demo-form',
                template: "<div class=\"demo-modal\">\n  <div class=\"demo\">\n    <span (click)=\"close()\" class=\"close\">x close</span>\n    <div class=\"copy\">\n      <h1>Ready for<br />a demo?</h1>\n      <h3>Please contact us and we'll be in touch shortly.</h3>\n      <p>By submitting your email address, you<br />agree to be contacted by Sparkbox.</p>\n    </div>\n    <div class=\"form\">\n      <form>\n        <input [ngModelOptions]=\"{standalone: true}\" [(ngModel)]=\"name\" placeholder=\"Name *\" />\n        <input [ngModelOptions]=\"{standalone: true}\" [(ngModel)]=\"email\" placeholder=\"Email *\" />\n        <textarea [ngModelOptions]=\"{standalone: true}\" [(ngModel)]=\"message\" placeholder=\"Message\"></textarea>\n        <button (click)=\"submit()\">Send</button>\n      </form>\n    </div>\n  </div>\n</div>",
                styles: [".demo-modal{height:100vh;width:100vw;position:absolute;left:0;top:0;display:-webkit-box;display:flex;-webkit-box-align:center;align-items:center;-webkit-box-pack:center;justify-content:center;background:rgba(0,0,0,.15);z-index:1112}.demo{background:#f3f5d7;width:675px;height:395px;display:-webkit-box;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;flex-direction:row;max-width:50%;position:relative}.demo>*{height:100%}.close{position:absolute;top:8px;right:13px;font-size:10px;color:#2f2e2e;font-weight:100;cursor:pointer}.copy{padding-left:52px}.copy h1{margin:31px 0 22px;font-size:40px;line-height:1.2em;font-weight:400;text-transform:lowercase}.copy h3{font-size:18px;line-height:1.3em;font-weight:100}.copy p{font-size:10px;position:absolute;bottom:52px;left:52px;color:#2f2e2e;font-weight:100}.form{padding:52px;box-sizing:border-box}.form input{height:26px}.form input:first-of-type{margin-bottom:11px}.form textarea{margin-top:11px;resize:none;height:97px;line-height:97px}.form input,.form textarea{font-size:15px;padding:3px 3px 3px 18px;background:#fff;border-radius:0;border:1px solid #000;box-shadow:none;width:calc(100% - 23px)}.form input::-webkit-input-placeholder,.form textarea::-webkit-input-placeholder{color:#000!important;font-weight:100!important;font-family:Rubik,sans-serif!important}.form input::-moz-placeholder,.form textarea::-moz-placeholder{color:#000!important;font-weight:100!important;font-family:Rubik,sans-serif!important}.form input:-ms-input-placeholder,.form textarea:-ms-input-placeholder{color:#000!important;font-weight:100!important;font-family:Rubik,sans-serif!important}.form input::-ms-input-placeholder,.form textarea::-ms-input-placeholder{color:#000!important;font-weight:100!important;font-family:Rubik,sans-serif!important}.form input::placeholder,.form textarea::placeholder{color:#000!important;font-weight:100!important;font-family:Rubik,sans-serif!important}.form button{background:#1a1a1a;cursor:pointer;color:#fff;position:absolute;height:46px;width:128px;bottom:82px;right:52px;font-family:Rubik,sans-serif!important;font-size:16px;border:none;font-weight:100}"]
            }] }
];
/** @nocollapse */
DemoFormComponent.ctorParameters = () => [
    { type: DemoFormService }
];
DemoFormComponent.propDecorators = {
    closeClicked: [{ type: Output }]
};
if (false) {
    /** @type {?} */
    DemoFormComponent.prototype.closeClicked;
    /** @type {?} */
    DemoFormComponent.prototype.message;
    /** @type {?} */
    DemoFormComponent.prototype.email;
    /** @type {?} */
    DemoFormComponent.prototype.name;
    /**
     * @type {?}
     * @private
     */
    DemoFormComponent.prototype.demoFormService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class SbxUiCoreModule {
}
SbxUiCoreModule.decorators = [
    { type: NgModule, args: [{
                declarations: [
                    SbxUiCoreComponent,
                    UserMenuComponent,
                    InsightHeaderComponent,
                    PlugAndPlayComponent,
                    LineChartComponent,
                    DemoFormComponent
                ],
                imports: [FormsModule, CommonModule, RouterModule, ChartsModule],
                providers: [
                    {
                        provide: HTTP_INTERCEPTORS,
                        useClass: AuthInterceptor,
                        multi: true,
                    },
                    ThemeService,
                ],
                exports: [SbxUiCoreComponent, UserMenuComponent, InsightHeaderComponent, PlugAndPlayComponent, LineChartComponent, DemoFormComponent],
            },] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function User() { }
if (false) {
    /** @type {?} */
    User.prototype.fullName;
    /** @type {?} */
    User.prototype.role;
    /** @type {?} */
    User.prototype.nickname;
    /** @type {?} */
    User.prototype.email;
    /** @type {?|undefined} */
    User.prototype.dbName;
    /** @type {?|undefined} */
    User.prototype.insightDepartments;
    /** @type {?|undefined} */
    User.prototype.insightSeasons;
    /** @type {?|undefined} */
    User.prototype.insightCollections;
    /** @type {?|undefined} */
    User.prototype.insightMaximumProductAge;
    /** @type {?|undefined} */
    User.prototype.insightMinimumProductAge;
    /** @type {?} */
    User.prototype.currency;
}
class UserService {
    /**
     * @param {?} http
     */
    constructor(http) {
        this.http = http;
        this.user$ = new BehaviorSubject(null);
        this.get()
            .pipe(first$1())
            .subscribe((/**
         * @param {?} user
         * @return {?}
         */
        user => {
            this.user$.next(user);
        }));
    }
    /**
     * @param {?} property
     * @param {?} value
     * @return {?}
     */
    updateUserProperty(property, value) {
        this.http.post('/api/user', { [property]: value }).subscribe((/**
         * @param {?} user
         * @return {?}
         */
        user => {
            this.user$.next(user);
        }));
    }
    /**
     * @private
     * @return {?}
     */
    get() {
        return this.http.get('/api/user');
    }
}
UserService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root',
            },] }
];
/** @nocollapse */
UserService.ctorParameters = () => [
    { type: HttpClient }
];
/** @nocollapse */ UserService.ngInjectableDef = ɵɵdefineInjectable({ factory: function UserService_Factory() { return new UserService(ɵɵinject(HttpClient)); }, token: UserService, providedIn: "root" });
if (false) {
    /** @type {?} */
    UserService.prototype.user$;
    /**
     * @type {?}
     * @private
     */
    UserService.prototype.http;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class UserFacadeService {
    /**
     * @param {?} userService
     */
    constructor(userService) {
        this.userService = userService;
    }
    /**
     * @param {?} property
     * @return {?}
     */
    getUserProperty(property) {
        return this.userService.user$.pipe(map((/**
         * @param {?} user
         * @return {?}
         */
        user => pickBy(user, (/**
         * @param {?} val
         * @param {?} key
         * @return {?}
         */
        (val, key) => property.includes(key))))));
    }
    /**
     * @return {?}
     */
    getUserFullName() {
        return this.getUserProperty(['fullName']).pipe(map((/**
         * @param {?} __0
         * @return {?}
         */
        ({ fullName }) => fullName)));
    }
    /**
     * @return {?}
     */
    getUserNickname() {
        return this.getUserProperty(['nickname']).pipe(map((/**
         * @param {?} __0
         * @return {?}
         */
        ({ nickname }) => nickname)));
    }
    /**
     * @return {?}
     */
    getUserCurrency() {
        return this.getUserProperty(['currency']).pipe(map((/**
         * @param {?} __0
         * @return {?}
         */
        ({ currency }) => currency)));
    }
    /**
     * @return {?}
     */
    getUserInsightDepartments() {
        return this.getUserProperty(['insightDepartments']).pipe(map((/**
         * @param {?} __0
         * @return {?}
         */
        ({ insightDepartments }) => insightDepartments)));
    }
    /**
     * @param {?} value
     * @return {?}
     */
    updateUserInsightDepartments(value) {
        this.userService.updateUserProperty('insightDepartments', value);
    }
    /**
     * @return {?}
     */
    getUserInsightSeasons() {
        return this.getUserProperty(['insightSeasons']).pipe(map((/**
         * @param {?} __0
         * @return {?}
         */
        ({ insightSeasons }) => insightSeasons)));
    }
    /**
     * @param {?} value
     * @return {?}
     */
    updateUserInsightSeasons(value) {
        this.userService.updateUserProperty('insightSeasons', value);
    }
    /**
     * @return {?}
     */
    getUserInsightCollections() {
        return this.getUserProperty(['insightCollections']).pipe(map((/**
         * @param {?} __0
         * @return {?}
         */
        ({ insightCollections }) => insightCollections)));
    }
    /**
     * @param {?} value
     * @return {?}
     */
    updateUserInsightCollections(value) {
        this.userService.updateUserProperty('insightCollections', value);
    }
    /**
     * @return {?}
     */
    getUserInsightMaxProductAge() {
        return this.getUserProperty(['insightMaximumProductAge']).pipe(map((/**
         * @param {?} __0
         * @return {?}
         */
        ({ insightMaximumProductAge }) => insightMaximumProductAge)));
    }
    /**
     * @param {?} value
     * @return {?}
     */
    updateUserInsightMaxProductAge(value) {
        this.userService.updateUserProperty('insightMaximumProductAge', value);
    }
    /**
     * @return {?}
     */
    getUserInsightMinProductAge() {
        return this.getUserProperty(['insightMinimumProductAge']).pipe(map((/**
         * @param {?} __0
         * @return {?}
         */
        ({ insightMinimumProductAge }) => insightMinimumProductAge)));
    }
    /**
     * @param {?} value
     * @return {?}
     */
    updateUserInsightMinProductAge(value) {
        this.userService.updateUserProperty('insightMinimumProductAge', value);
    }
}
UserFacadeService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root',
            },] }
];
/** @nocollapse */
UserFacadeService.ctorParameters = () => [
    { type: UserService }
];
/** @nocollapse */ UserFacadeService.ngInjectableDef = ɵɵdefineInjectable({ factory: function UserFacadeService_Factory() { return new UserFacadeService(ɵɵinject(UserService)); }, token: UserFacadeService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    UserFacadeService.prototype.userService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class MerchHierarchyService {
    /**
     * @param {?} http
     */
    constructor(http) {
        this.http = http;
        this.merchHierarchy$ = new BehaviorSubject(null);
        this.allMerchHierarchy$ = new BehaviorSubject(null);
        this.get()
            .pipe(first$1())
            .subscribe((/**
         * @param {?} merchHierarchy
         * @return {?}
         */
        merchHierarchy => {
            this.merchHierarchy$.next(merchHierarchy);
        }));
        this.getAllMerchHierarchy()
            .pipe(first$1())
            .subscribe((/**
         * @param {?} merchHierarchy
         * @return {?}
         */
        merchHierarchy => {
            this.allMerchHierarchy$.next(merchHierarchy);
        }));
    }
    /**
     * @return {?}
     */
    get() {
        return this.http.get('/api/ref/org/merch-hierarchy/h2');
    }
    /**
     * @return {?}
     */
    getAllMerchHierarchy() {
        return this.http.get('/api/ref/org/merch-hierarchy');
    }
    /**
     * @param {?} params
     * @return {?}
     */
    updateMerchHierarchy(params) {
        this.http.post('/api/ref/org/merch-hierarchy', params).subscribe((/**
         * @param {?} merchHierarchy
         * @return {?}
         */
        merchHierarchy => {
            this.allMerchHierarchy$.next(merchHierarchy);
        }));
    }
}
MerchHierarchyService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root',
            },] }
];
/** @nocollapse */
MerchHierarchyService.ctorParameters = () => [
    { type: HttpClient }
];
/** @nocollapse */ MerchHierarchyService.ngInjectableDef = ɵɵdefineInjectable({ factory: function MerchHierarchyService_Factory() { return new MerchHierarchyService(ɵɵinject(HttpClient)); }, token: MerchHierarchyService, providedIn: "root" });
if (false) {
    /** @type {?} */
    MerchHierarchyService.prototype.merchHierarchy$;
    /** @type {?} */
    MerchHierarchyService.prototype.allMerchHierarchy$;
    /**
     * @type {?}
     * @private
     */
    MerchHierarchyService.prototype.http;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class SeasonService {
    /**
     * @param {?} http
     */
    constructor(http) {
        this.http = http;
        this.season$ = new BehaviorSubject(null);
        this.get()
            .pipe(first$1())
            .subscribe((/**
         * @param {?} season
         * @return {?}
         */
        season => {
            this.season$.next(season);
        }));
    }
    /**
     * @return {?}
     */
    get() {
        return this.http.get('/api/ref/org/season');
    }
}
SeasonService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root',
            },] }
];
/** @nocollapse */
SeasonService.ctorParameters = () => [
    { type: HttpClient }
];
/** @nocollapse */ SeasonService.ngInjectableDef = ɵɵdefineInjectable({ factory: function SeasonService_Factory() { return new SeasonService(ɵɵinject(HttpClient)); }, token: SeasonService, providedIn: "root" });
if (false) {
    /** @type {?} */
    SeasonService.prototype.season$;
    /**
     * @type {?}
     * @private
     */
    SeasonService.prototype.http;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function Region() { }
if (false) {
    /** @type {?} */
    Region.prototype.id;
    /** @type {?} */
    Region.prototype.description;
    /** @type {?} */
    Region.prototype.code;
    /** @type {?} */
    Region.prototype.web_code;
    /** @type {?} */
    Region.prototype.vat_rate;
}
class RegionService {
    /**
     * @param {?} http
     */
    constructor(http) {
        this.http = http;
        this.region$ = new BehaviorSubject(null);
        this.get()
            .pipe(first$1())
            .subscribe((/**
         * @param {?} region
         * @return {?}
         */
        region => {
            this.region$.next(region);
        }));
    }
    /**
     * @return {?}
     */
    get() {
        return this.http.get('/api/ref/org/region');
    }
}
RegionService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root',
            },] }
];
/** @nocollapse */
RegionService.ctorParameters = () => [
    { type: HttpClient }
];
/** @nocollapse */ RegionService.ngInjectableDef = ɵɵdefineInjectable({ factory: function RegionService_Factory() { return new RegionService(ɵɵinject(HttpClient)); }, token: RegionService, providedIn: "root" });
if (false) {
    /** @type {?} */
    RegionService.prototype.region$;
    /**
     * @type {?}
     * @private
     */
    RegionService.prototype.http;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CollectionService {
    /**
     * @param {?} http
     */
    constructor(http) {
        this.http = http;
        this.collection$ = new BehaviorSubject(null);
        this.get()
            .pipe(first$1())
            .subscribe((/**
         * @param {?} collection
         * @return {?}
         */
        collection => {
            this.collection$.next(collection);
        }));
    }
    /**
     * @return {?}
     */
    get() {
        return this.http.get('/api/ref/org/collection');
    }
}
CollectionService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
CollectionService.ctorParameters = () => [
    { type: HttpClient }
];
/** @nocollapse */ CollectionService.ngInjectableDef = ɵɵdefineInjectable({ factory: function CollectionService_Factory() { return new CollectionService(ɵɵinject(HttpClient)); }, token: CollectionService, providedIn: "root" });
if (false) {
    /** @type {?} */
    CollectionService.prototype.collection$;
    /**
     * @type {?}
     * @private
     */
    CollectionService.prototype.http;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class RefFacadeService {
    /**
     * @param {?} merchHierarchyService
     * @param {?} seasonService
     * @param {?} regionService
     * @param {?} collectionService
     */
    constructor(merchHierarchyService, seasonService, regionService, collectionService) {
        this.merchHierarchyService = merchHierarchyService;
        this.seasonService = seasonService;
        this.regionService = regionService;
        this.collectionService = collectionService;
    }
    /**
     * @return {?}
     */
    getMerchHierarchy() {
        return this.merchHierarchyService.merchHierarchy$;
    }
    /**
     * @return {?}
     */
    getSeason() {
        return this.seasonService.season$;
    }
    /**
     * @return {?}
     */
    getRegion() {
        return this.regionService.region$;
    }
    /**
     * @return {?}
     */
    getCollection() {
        return this.collectionService.collection$;
    }
    /**
     * @return {?}
     */
    getAllMerchHierarchy() {
        return this.merchHierarchyService.allMerchHierarchy$;
    }
    /**
     * @param {?} params
     * @return {?}
     */
    updateMerchHierarchy(params) {
        this.merchHierarchyService.updateMerchHierarchy(params);
    }
}
RefFacadeService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root',
            },] }
];
/** @nocollapse */
RefFacadeService.ctorParameters = () => [
    { type: MerchHierarchyService },
    { type: SeasonService },
    { type: RegionService },
    { type: CollectionService }
];
/** @nocollapse */ RefFacadeService.ngInjectableDef = ɵɵdefineInjectable({ factory: function RefFacadeService_Factory() { return new RefFacadeService(ɵɵinject(MerchHierarchyService), ɵɵinject(SeasonService), ɵɵinject(RegionService), ɵɵinject(CollectionService)); }, token: RefFacadeService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    RefFacadeService.prototype.merchHierarchyService;
    /**
     * @type {?}
     * @private
     */
    RefFacadeService.prototype.seasonService;
    /**
     * @type {?}
     * @private
     */
    RefFacadeService.prototype.regionService;
    /**
     * @type {?}
     * @private
     */
    RefFacadeService.prototype.collectionService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { AuthInterceptor, PlugAndPlayComponent, RefFacadeService, SbxUiCoreModule, UserFacadeService, UserMenuComponent, SbxUiCoreComponent as ɵa, InsightHeaderComponent as ɵb, PlugAndPlayService as ɵc, LineChartComponent as ɵd, DemoFormComponent as ɵe, DemoFormService as ɵf, UserService as ɵg, MerchHierarchyService as ɵh, SeasonService as ɵi, RegionService as ɵj, CollectionService as ɵk };
//# sourceMappingURL=sbx-ui-core.js.map
